module.exports = __webpack_public_path__ + "media/LInsanePyramid.5163d783.mp4";